var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aha-modal',{attrs:{"title":_vm.category.value,"size":"3xl"},on:{"hide":function($event){return _vm.$emit('hide')}}},[_c('section',{staticClass:"correct-options"},_vm._l((_vm.category.options),function(option,index){return _c('div',{key:index,staticClass:"option"},[_vm._v("\n      "+_vm._s(option.value)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }